import { RequestNewVersion } from '../../../classes/RequestNewVersion';

export const getHistoryRemission = async (id_document) => {
  try {
    const request = new RequestNewVersion(
      `${process.env.REACT_APP_URL_API_LARAVEL}/document_expedients/remissions/history/${id_document}`,
      'get',
      null,
      {}
    );
    const response = await request.executeRequest();

    if (response.code !== 200) {
      return null;
    }

    return response.response;
  } catch (err) {
    return null;
  }
};
